"use client";

import Image from "next/image";
import { BRANDING } from "@/config/branding";

interface LogoProps {
  className?: string;
}

export default function Logo({ className = "" }: LogoProps) {
  return (
    <Image
      src="/assets/logo.svg"
      alt={BRANDING.logoAlt}
      width={330}
      height={120}
      className={`h-auto w-full max-w-[280px] sm:max-w-[360px] ${className}`}
      priority
    />
  );
}
